import NavBar from '../components/navbar';
import Footer from '../components/footer';

function VentHaven() {
    return (
        <>
            <title>VentHaven 2023</title>
            {/* Navigation Bar w/NavBurger BEGIN */}
            <NavBar />
            {/* Navigation Bar w/NavBurger End */}

            <h1 style={{ fontSize: 50, textAlign: "center", marginTop: 35 }}>
                VentHaven Convention <br />
                Summer 2023
            </h1>
            <div className="gallery-convention">
                <div className="image-container" style={{}}>
                    <img src="/assets/img/convention/IMG_5161.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5175.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5180.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5181.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_3844.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5184.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5185.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5186.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5198.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5199.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5200.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5205.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5206.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5214.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5216.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5221.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5222.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5223.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5225.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5227.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5229.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5230.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5231.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5238.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5240.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5245.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5246.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5248.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5251.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5253.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5260.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5270.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5271.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5273.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5274.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5276.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5277.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5278.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5279.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5281.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5282.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5284.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5288.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5289.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5290.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5291.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5292.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5293.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5294.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5297.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5298.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5320.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5323.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5324.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5328.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5333.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5335.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5160.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_5339.jp2" alt="" />
                    <img src="/assets/img/convention/IMG_.jp2" alt="" />
                </div>
            </div>


            {/* Footer */}
            <Footer />
            {/* Footer END */}
        </>
    );
}

export default VentHaven;